// extracted by mini-css-extract-plugin
export default {"btn_container":"GrabBitBtn_btn_container__+WWRu","btn":"GrabBitBtn_btn__zGGbL","img":"GrabBitBtn_img__MS+IU"};